import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import type { AssistantLiveTurn } from '@/hooks/useAssistantTurn';
import { useAssistantUi } from './uiActions/assistantUiContext';

export function useReplyAnnouncements(liveTurn: AssistantLiveTurn | null): void {
  const { t } = useTranslation('assistant');
  const { announce } = useAssistantUi();
  const announcedRef = useRef<string>('');
  const generation = liveTurn === null ? null : liveTurn.generation;
  const status = liveTurn === null ? null : liveTurn.status;

  useEffect(
    function announceReplyProgress() {
      if (generation === null || status === null || status === 'asking') {
        return;
      }
      const announcementKey = String(generation) + ':' + status;
      if (announcedRef.current === announcementKey) {
        return;
      }
      announcedRef.current = announcementKey;
      if (status === 'streaming') {
        announce(t('announcements.replying'));
      } else if (status === 'completed') {
        announce(t('announcements.replyReady'));
      } else {
        announce(t('announcements.replyFailed'));
      }
    },
    [announce, generation, status, t]
  );
}
